import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import {
  Dropdown,
  DropdownOptionLabel,
} from '@sorare/core/src/atoms/dropdowns/Dropdown';
import { ChevronDownBold } from '@sorare/core/src/atoms/icons/ChevronDownBold';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelM } from '@sorare/core/src/atoms/typography';
import { createCardSorts } from '@sorare/core/src/lib/algolia';
import { sorts } from '@sorare/core/src/lib/glossary';
import { PlayerSearchViewAttributes } from '@sorare/core/src/lib/playerSearchView';
import {
  laptopAndAbove,
  tabletAndAbove,
} from '@sorare/core/src/style/mediaQuery';

import { useManagePlayerSearchView } from 'searchCommonPlayer/StatsManager/useManagePlayerSearchView';

const Header = styled(Horizontal)`
  background-color: var(--c-black);
  position: sticky;
  z-index: 1;
  padding: var(--double-unit) var(--double-unit) var(--unit);
  justify-content: space-between;
  top: calc(9 * var(--unit) + 1px);

  @media ${tabletAndAbove} {
    top: calc(11 * var(--unit) + 1px);
  }
  @media ${laptopAndAbove} {
    padding: var(--triple-unit) var(--triple-unit) var(--double-unit);
  }
`;

const cardSorts = createCardSorts({
  indexPrefix: 'Cards On Sale',
});

type Props = {
  count: number;
};

export const ManagerSalesHeader = ({ count }: Props) => {
  const { statsManager, updatePlayerSearchViewAttribute } =
    useManagePlayerSearchView();
  const selected =
    (cardSorts.includes(statsManager[PlayerSearchViewAttributes.CARDS_SORT]) &&
      statsManager[PlayerSearchViewAttributes.CARDS_SORT]) ||
    cardSorts[0];
  if (!count) return null;
  return (
    <Header>
      <LabelM>
        <FormattedMessage
          id="playerMarketDrawer.secondaryOffers.count"
          defaultMessage="{count, plural, one {1 listing} other {# listings}}"
          values={{ count }}
        />
      </LabelM>
      <Dropdown
        align="right"
        label={({ open, ...props }) => (
          <Button
            size="small"
            color="tertiary"
            endIcon={<ChevronDownBold className={open ? 'chevron-up' : ''} />}
            {...props}
          >
            <FormattedMessage {...sorts[selected]} />
          </Button>
        )}
        closeOnChange
      >
        {({ closeDropdown }) =>
          cardSorts.map(s => (
            <DropdownOptionLabel
              key={s}
              onClick={() => {
                updatePlayerSearchViewAttribute(
                  PlayerSearchViewAttributes.CARDS_SORT,
                  s
                );
                closeDropdown();
              }}
            >
              <FormattedMessage {...sorts[s]} />
            </DropdownOptionLabel>
          ))
        }
      </Dropdown>
    </Header>
  );
};
